import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import NewsRow from '@/components/base/NewsRow';
import { newsList } from '@/mocks/newsList';

export default function NewsSection() {
  const items = [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 5);

  return (
    <section>
      <SectionHeading
        title="影视资讯精选"
        subtitle="行业动态、剧情解读与幕后故事"
        action={
          <Link
            to="/category/news"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-label text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            更多资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="bg-background-50 border border-background-200 rounded-lg px-4 md:px-5">
        {items.map((item) => (
          <NewsRow key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}